import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
// redux
import { getTaxRates, getTaxRate } from 'src/redux/slices/tax';
import BookkeepingTaxEditForm from '../bookkeeping-tax-edit-form';
import { useDispatch, useSelector } from '../../../../redux/store';
import { useLocales } from '../../../../locales';

// ----------------------------------------------------------------------

export default function BookkeepingTaxEditView() {
  const [searchParams] = useSearchParams();

  const taxRates = useSelector((state) => state.tax.taxRates);

  const searchId = searchParams
    .get('id')
    ?.split(',')
    .filter((x) => !taxRates.find((tx) => tx.id === Number(x)))
    .map((x) => Number(x));

  const settings = useSettingsContext();

  const { t } = useLocales();

  const dispatch = useDispatch();

  if (taxRates && searchId) {
    dispatch(getTaxRate(searchId));
  }

  useEffect(() => {
    dispatch(getTaxRates());
  }, [dispatch]);

  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
      <CustomBreadcrumbs
        heading={t('Edit')}
        links={[
          {
            name: `${t('Dashboard')}`,
            href: paths.dashboard.root,
          },
          {
            name: `${t('VAT')}`,
            href: paths.bookkeeping.root,
          },
          { name: `${t('Settings')}` },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <BookkeepingTaxEditForm taxRates={taxRates} />
    </Container>
  );
}
